var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 21C42.5 32.598 33.098 42 21.5 42C9.90202 42 0.5 32.598 0.5 21C0.5 9.40202 9.90202 0 21.5 0C33.098 0 42.5 9.40202 42.5 21ZM21.5 10.5C20.0945 10.5 18.9963 11.7135 19.1362 13.112L20.0569 22.319C20.131 23.0604 20.7549 23.625 21.5 23.625C22.2451 23.625 22.869 23.0604 22.9431 22.319L23.8638 13.112C24.0037 11.7135 22.9055 10.5 21.5 10.5ZM21.504 26.25C20.0543 26.25 18.879 27.4253 18.879 28.875C18.879 30.3247 20.0543 31.5 21.504 31.5C22.9538 31.5 24.129 30.3247 24.129 28.875C24.129 27.4253 22.9538 26.25 21.504 26.25Z",
    fill: "#FF009E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPink);
export default __webpack_public_path__ + "static/media/exclamation-pink.500b745e58118af1554b6550f7b24d12.svg";
export { ForwardRef as ReactComponent };